import { render, staticRenderFns } from "./pdf-signer.vue?vue&type=template&id=12a9e15e&scoped=true&"
import script from "./pdf-signer.vue?vue&type=script&lang=ts&"
export * from "./pdf-signer.vue?vue&type=script&lang=ts&"
import style0 from "./pdf-signer.vue?vue&type=style&index=0&id=12a9e15e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9e15e",
  null
  
)

export default component.exports